module.exports = __webpack_public_path__ + "static/muli-v16-latin-regular-b0f17b38ff3123d07235537f07affb6b.woff";